import { useQuery } from '@apollo/react-hooks';
import { GET_MANAGERS } from '../../graphql/user/query';
import { Managers } from '../../graphql/user/types/Managers';

export const useGetManagers = () => {
  return useQuery<Managers>(GET_MANAGERS, {
    fetchPolicy: 'network-only',
  });
};
